<template>
  <navbar
    position="fixed"
    type="primary"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template>
      <router-link class="navbar-brand" to="/">
        Blumen-Twins
      </router-link>
    </template>
    <template slot="navbar-menu">
      <drop-down
              tag="li"
              title="Blumen"
              icon="mdi mdi-flower-outline"
              class="nav-item"
      >
        <nav-link to="/wedding">
          <!--
          <div class="logo-container">
            <span class="mdi mdi-file-document-outline"></span>
          </div>
          -->
          <p class="ml-2">Hochzeit</p>
        </nav-link>
        <nav-link to="/funeral">
          <!--
          <div class="logo-container">
            <span class="mdi mdi-account-eye-outline"></span>
          </div>
          -->
          <p class="ml-2">Beerdigung</p>
        </nav-link>
        <nav-link to="/bouquets">
          <!--
          <div class="logo-container">
            <span class="mdi mdi-wheelchair"></span>
          </div>
          -->
          <p class="ml-2">Sträuße</p>
        </nav-link>
        <nav-link to="/all-souls-day">
          <!--
          <div class="logo-container">
            <span class="mdi mdi-wheelchair"></span>
          </div>
          -->
          <p class="ml-2">Totensonntag</p>
        </nav-link>
        <nav-link to="/christmas">
          <!--
          <div class="logo-container">
            <span class="mdi mdi-wheelchair"></span>
          </div>
          -->
          <p class="ml-2">Weihnachten</p>
        </nav-link>
      </drop-down>
      <drop-down
              tag="li"
              title="Infos"
              icon="mdi mdi-text"
              class="nav-item"
      >
        <nav-link to="/legal">
          <div class="logo-container">
            <span class="mdi mdi-file-document-outline"></span>
          </div>
          <p class="ml-2">Impressum</p>
        </nav-link>
        <nav-link to="/privacy">
          <div class="logo-container">
            <span class="mdi mdi-account-eye-outline"></span>
          </div>
          <p class="ml-2">Datenschutzerklärung</p>
        </nav-link>
        <nav-link to="/accessibility">
          <div class="logo-container">
            <span class="mdi mdi-wheelchair"></span>
          </div>
          <p class="ml-2">Barrierefreiheit</p>
        </nav-link>
      </drop-down>
    </template>
  </navbar>
</template>

<script>
import { DropDown, Navbar, NavLink } from '@/components';
import { Popover } from 'element-ui';
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavLink,
    [Popover.name]: Popover
  }
};
</script>

<style scoped>
.container {
  flex-direction: row;
}
.logo-container {
  height: 22px !important;
  width: 22px !important;
  display: flex;
  align-items: center;
  justify-content: center;

  .mdi {
    height: 100%;
    width: 100%;

    font-size: 20px;
    line-height: 20px;
  }
}
.logo-img {
  height: 100%;
  width: 100%;
}
.nav-item {
  width: 100%;

  .nav-link {
    display: flex;
    align-items: center;
    flex-direction: row;
  }
}
</style>
